import {useEffect} from 'react';
import {useDispatch} from 'react-redux';
import {enableAuthButtonsAccess} from '@Components/login-page/login-page-reducer';
import {hideGrecaptchaBadge, showGrecaptchaBadge} from '@Libraries/recaptcha-library';
import {useIsRecaptchaLoaded} from '@/hooks/recaptcha/useIsRecaptchaLoaded';

export const useOnRecaptchaRender = (): {
  showGrecaptchaBadge: () => void;
  hideGrecaptchaBadge: () => void;
} => {
  const isRecaptchaLoaded = useIsRecaptchaLoaded();
  const dispatch = useDispatch();

  useEffect(() => {
    if (isRecaptchaLoaded) {
      window.PMW.grecaptchaReady = true;
      dispatch(enableAuthButtonsAccess());
      showGrecaptchaBadge();
    }
  }, [isRecaptchaLoaded]);

  return {showGrecaptchaBadge, hideGrecaptchaBadge};
};
